import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './App.scss';
import App from './App';
import { store } from './Store/store';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react';
import ClerkAxiosInterceptor from './components/ClerkAxiosInterceptor';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || "pk_test_Z3VpZGluZy1oZWRnZWhvZy00MS5jbGVyay5hY2NvdW50cy5kZXYk";

if (!process.env.REACT_APP_CLERK_PUBLISHABLE_KEY) {
  console.warn("⚠️ REACT_APP_CLERK_PUBLISHABLE_KEY is missing from .env. Using fallback test key. Please configure it to enable authentication via API.");
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <Provider store={store}>
        <ClerkAxiosInterceptor>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ClerkAxiosInterceptor>
      </Provider>
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
